import { render, staticRenderFns } from "./AdvancedSettings.vue?vue&type=template&id=59cd1732"
import script from "./AdvancedSettings.vue?vue&type=script&lang=js"
export * from "./AdvancedSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports